export default __webpack_public_path__ + "static/media/book-6.abe09166.png";